import { render, staticRenderFns } from "./FAQDSS.vue?vue&type=template&id=6cabf09f&scoped=true"
import script from "./FAQDSS.vue?vue&type=script&lang=js"
export * from "./FAQDSS.vue?vue&type=script&lang=js"
import style0 from "./FAQDSS.vue?vue&type=style&index=0&id=6cabf09f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cabf09f",
  null
  
)

export default component.exports